import { IFile } from '@repo/toolkit/types'
import { PaginationSort } from '@repo/ui/data-table'

import { Translation } from '../translation/translation'
import { Trip } from '../trip/trip'

export type TransportMeans = {
  id: number
  // the name in every locale (FR always present), read with getTranslatedName
  translations: Translation[]
  code: string
  picto?: IFile
  pictoId?: number

  howManyQuarterBeforeDepartureForParents?: number
  howManyQuarterBeforeDepartureForStaff?: number
  howManyQuarterBeforeDepartureForLEC?: number
  howManyQuarterBeforeDepartureForGroup?: number
  howManyQuarterBeforeArrivalForForeignProvider?: number
  howManyQuarterAfterArrivalForForeignProvider?: number

  howManyQuarterBeforeArrivalForLEC?: number
  howManyQuarterBeforeArrivalForParents?: number

  trips: Trip[]
}

export const PLANE_TRANSPORT_MEANS_CODE = 'Avion'

export type TransportMeansBasic = Pick<TransportMeans, 'id' | 'translations'>

export type TransportMeansLight = Pick<TransportMeans, 'id' | 'translations' | 'picto'>

// sorted by the backend on the French name
export type TransportMeansSort = PaginationSort<
  Pick<TransportMeans, 'id' | 'code'> & { name: string }
>
